export enum I9Status {
  DRAFT = 'draft',
  ALL_PENDING = 'pending',
  SECTION1_COMPLETED = 'section1Completed',
  SECTION1_PENDING = 'section1Pending',
  SECTION2_COMPLETED = 'section2Completed',
  DIGITIZED = 'digitized',
  /** RQA-03 — a digitized record whose remediation is complete. Terminal, like DIGITIZED. */
  REMEDIATED = 'remediated',
}

export const I9_STATUS_DISPLAY = {
  [I9Status.DRAFT]: 'Section 1 Draft',
  [I9Status.ALL_PENDING]: 'Pending',
  [I9Status.SECTION1_COMPLETED]: 'Section 2 Pending',
  [I9Status.SECTION2_COMPLETED]: 'Section 2 Complete',
  [I9Status.SECTION1_PENDING]: 'Section 1 Pending',
  [I9Status.DIGITIZED]: 'Digitized',
  [I9Status.REMEDIATED]: 'Remediated',
};
